<template>
  <div id="macarons1"></div>

</template>

<script>
export default {
  props: {
    source: {
      type: Array,
      default: [],
    },
    titleList: {
      type: Array,
      default: [],
    },
    dataList:{
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      chart: null,
    };
  },
watch: {
    source(val) {
      if (val) {
        this.initChart();
      }
    },
    dataList(val){
      if(val){
         this.initChart();
      }
    }
  },
mounted(){
},
  methods: {
    // 便利数据
    voListmap(item){
       let leyItem=[]
      if(item){
        for( let  i = 0; i < item.length; i++){
             leyItem.push(item[i].key+':'+item[i].value)
         }
         return '('+leyItem.join()+')'
      }else{
         return leyItem=''
      }
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("macarons1"));
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter:  (param)=> {
          let  dataList= this.dataList && this.dataList.filter(item=>{
            if(item.key==param[0].name){
              return item
            }
           })
           let voList=dataList.length && dataList[0].voList
           var list = []
           var listItem = ''
           var html = ''
          html +=`<span style='display:inline-block;background-color:${param[0].color};width:10px;height:10px;border-radius:5px;'></span> ${param[0].name}:  ${param[0].value}<br/>`
          for (var i = 0; i < voList.length; i++) {
            html += '<span style="width:200px; display:inline-block;">' +
               voList[i].key +
              ':' +
              voList[i].value +'家'+ '<span style="word-wrap:break-word;">'+this.voListmap(voList[i].voList)+'</span>'+
              '</span><br>'
          }
          list.push(html)
          listItem = list.join('<br>') // 通过数组的join()方法 实现<br>换行的效果
          return '<div class="showBox">' + listItem + '</div>'

            // return (
            //   `<span style='display:inline-block;background-color:${param[0].color};width:10px;height:10px;border-radius:5px;'></span>
            //   ${param[0].name}:  ${param[0].value}`
            //   +`<br />`
            //   +`<div v-for(item,index) in item :key="index"> ${item}</div>`
            // );
          },
        },
        grid: {
          left: 0,
          right: 0,
          bottom: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          data: this.titleList,
          // boundaryGap: [0, 0.01],
          show:false,
          axisLine: {
            lineStyle: {
              // color:"#fff",
              width: 1,
              show: true,
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
        },
        yAxis: [{
          type: 'category',
          // offset: -20,
          position: "left",
          axisLabel: {
            color: '#fff',
            fontSize: 14
          },
          axisLine: {
            show: false
          },
          inverse: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#FFFFFF",
              fontSize: "16"
            },
            interval: 0,
            align: "left",
            padding: [0, 0, 16, 4],
            verticalAlign: "bottom",
          },
          data: this.titleList
        },
          {
            type: 'category',
            // offset: -20,
            position: "right",
            axisLabel: {
              color: '#fff',
              fontSize: 14
            },
            axisLine: {
              show: false
            },
            inverse: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "#FFFFFF",
                fontSize: "16"
              },
              interval: 0,
              align: "right",
              padding: [0, 16, 8, 0],
              verticalAlign: "bottom",
            },
            data: this.source
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            stack: "总量",
            label: {
              show: false,
              position: "insideRight",
            },
            data: this.source,
            yAxisIndex: 0,
            barWidth: 4,
            z: 2,
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                // label: {
                //   formatter: "{c}",
                //   show: true,
                //   position: "right",
                //   textStyle: {
                //     fontWeight: "bolder",
                //     fontSize: "12",
                //     color: "#fff",
                //   },
                // },
                color: function (params) {
                  //自定义颜色
                  var colorList = [
                  "#f99b79",
                  "#ff4500",
                  "#ff8c00",
                  "#90ee90",
                  "#1e90ff",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },

          },
          {
            type: "bar",
            // stack: "总量",
            label: {
              show: false,
              position: "insideRight",
            },
            data: [10, 10],
            barGap: "-100%",
            barWidth: 4,
            itemStyle: {
              normal: {
                color: "rgba(255, 255, 255, 0.15)",
                barBorderRadius: 6
              }
            },
            z: 0

          },
          {
            name: "",
            type: "pictorialBar",
            symbol:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAZlBMVEUAAABe3uVe3+Vf3uVf3+Zf3uVg3+Zg3+Zf3+Vi4OZh4OZg3+Z86/Bh3+Zi4Odj4Odi4OZ86/B76/B86/Bj4ed56+9x5+xn4umB7/N87PB36e+A7/N+7fF/7vJ/7vJ+7fGA7/OB7/PReX+lAAAAIXRSTlMABQkVDREmIhk3MR10LEFFPHh7cUprXE35h2XnqMLAp+mHAG9cAAAB5ElEQVRIx83WjU7CMBQFYIoiKMqU/XUboHv/l/Tce7t2XamDNSacETEmX86tlK2rx4py150o+MstMBLwWRfHKo6JCVxLnvmFGBjFQ58oF1//sUZhGy/ClSTWObgnL4O+bkeN4nY2okfNMbkRt9/vtxz8InoTsWplJSCzFxPmO8+GpSIByX3YQAuGDWtRKhKjCnxDXhF6Z4yxnZ20Wgko7BMRDmxtSGVaI4kdTIgb+zTYoJQlIMlDlmUFgrcDWWC201qSayqlTkiCddWWeV62VU0YlnpRi9VOKaSUsiyq/N0krwq2Ugt7lVpZl5BfHNiytjagMi+XYp0kCR45hMlivVQrE/uU5pXSrCB5bM6d1t2lOZItMqmliT3q5uVxqxzyW/ccfYLNKx7ZTeykMvNyac2yt2Fbc61MHLSC0rwoxbiNdlQ3GBm1NLHQsHUrtEXppR/ljNpW6DbSCoqlFiVoN6YdaFlgsSFVPs1BdT8OaB5QyQzVcaqWDows/zepxR8ObLglTrdtCRVuRNj4Rrxh+//0ke2f8KVL+Kon3GCSbmsJN9OUW3j6g0Ns+LgCij2u0h+Sghc8mlMPBMgdx5DFh59VmOVHrvmDnoNxCz3J7MFWsMuaLyR089xz/xhlfijvwutR8gv3zk6BLUUeCgAAAABJRU5ErkJggg==",
            symbolSize: [50, 50],
            symbolOffset: [20, 0],
            z: 12,
            symbolPosition:"end",
            data: this.source,
          },
        ],
      });
      // window.onresize = this.chart.resize;
      window.addEventListener("resize", this.chart.resize);
    },
  },
};
</script>

<style lang="less" scoped>
#macarons1 {
  width: 100%;
  height: calc(100% - 40px)
}
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homerightcenter.vue